<template>
    <div class="animated fadeIn">
        <b-card>
            <template #header>
                <span class="h5">Análise do Cronograma</span>
            </template>

            <div v-if="carregando" class="text-center my-4">
                <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
            </div>

            <template v-if="!carregando && dados">
                <cronograma-planejamento
                    :contrato="contrato"
                    :dados-planejamento="dados"
                    :status-cronograma="statusCronograma"
                    :motivo-devolucao="dados.motivoDevolucao || ''"
                    :quantidade-bms="quantidadeBms"
                    :modo-analise="true"
                />

                <div class="d-flex mt-3">
                    <b-button variant="warning" class="mr-2" @click="$router.back()">
                        <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Voltar
                    </b-button>
                    <template v-if="podeAnalisar">
                        <b-button variant="success" class="mr-2" @click="aprovar" :disabled="processando">
                            <i class="fa fa-check"></i> Aprovar
                        </b-button>
                        <b-button variant="danger" @click="$bvModal.show('modal-devolver')" :disabled="processando">
                            <i class="fa fa-undo"></i> Devolver
                        </b-button>
                    </template>
                </div>

                <hr />

                <h6 class="font-weight-bold mt-3">Histórico</h6>
                <app-tabela
                    :itens="historico"
                    :campos="histFields"
                    :bordered="false"
                    :small="true"
                    :mostrar-filtro="false"
                />
            </template>

            <div v-if="!carregando && !dados" class="text-center my-4 text-muted">
                Planejamento não encontrado para este contrato.
            </div>
        </b-card>

        <b-modal
            id="modal-devolver"
            title="Devolver Cronograma"
            ok-title="Devolver"
            ok-variant="danger"
            cancel-title="Cancelar"
            :ok-disabled="processando"
            @show="resetarModalDevolucao"
            @ok.prevent="confirmarDevolucao"
        >
            <b-form-group
                label="Motivo da devolução *"
                :state="motivoValido === null ? null : motivoValido"
                invalid-feedback="O motivo é obrigatório."
            >
                <b-form-textarea
                    v-model="motivo"
                    :state="motivoValido === null ? null : motivoValido"
                    rows="3"
                    placeholder="Descreva o motivo da devolução..."
                />
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import CronogramaPlanejamento from '@/app/fornecedor/contratos/boletinsMedicoes/CronogramaPlanejamento'
import CronogramaAprovacaoServicos from './CronogramaAprovacaoServicos'
import { statusCronogramaEnum } from '@/app/fornecedor/contratos/boletinsMedicoes/BoletimMedicao'

export default {
    name: 'DetalheCronogramaAprovacao',
    components: { CronogramaPlanejamento },
    data() {
        return {
            contratoId: this.$route.params.contratoId,
            contrato: null,
            dados: null,
            statusCronograma: statusCronogramaEnum.AguardandoAprovacao,
            historico: [],
            motivo: '',
            motivoTocado: false,
            processando: false,
            carregando: false,
            histFields: [
                { key: 'acao', label: 'Ação', sortable: true },
                { key: 'usuario', label: 'Usuário', sortable: true },
                {
                    key: 'dataHora',
                    label: 'Data/Hora',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-nowrap'
                },
                { key: 'motivo', label: 'Motivo', sortable: true }
            ]
        }
    },
    computed: {
        motivoValido() {
            if (!this.motivoTocado) return null
            return this.motivo.trim().length > 0
        },
        podeAnalisar() {
            return this.statusCronograma === statusCronogramaEnum.AguardandoAprovacao
        },
        quantidadeBms() {
            if (!this.dados || !this.dados.itens || this.dados.itens.length === 0) return 1
            const primeiroItem = this.dados.itens[0]
            const medicoes = primeiroItem.medicoes || primeiroItem.bms || []
            return medicoes.length > 0 ? medicoes.length : 1
        }
    },
    methods: {
        carregar() {
            this.carregando = true
            this.$store.dispatch('addRequest')

            const promPlanejamento = CronogramaAprovacaoServicos.obterPlanejamento(this.contratoId)
            const promHistorico = CronogramaAprovacaoServicos.obterHistorico(this.contratoId)

            Promise.all([promPlanejamento, promHistorico])
                .then(([resPlan, resHist]) => {
                    if (resPlan && resPlan.data) {
                        const planejamento = resPlan.data
                        this.dados = planejamento
                        this.statusCronograma = planejamento.statusCronograma || statusCronogramaEnum.AguardandoAprovacao
                        this.contrato = {
                            contratoId: this.contratoId,
                            valorTotal: planejamento.valorTotalContrato,
                            gestor: planejamento.gestor,
                            vigencia: planejamento.vigencia
                        }
                    }
                    this.historico = (resHist && resHist.data) ? resHist.data : []
                })
                .catch(() => {
                    this.$toast.error('Erro ao carregar dados do cronograma.')
                })
                .finally(() => {
                    this.carregando = false
                    this.$store.dispatch('removeRequest')
                })
        },

        aprovar() {
            if (this.processando) return
            this.processando = true
            this.$store.dispatch('addRequest')
            CronogramaAprovacaoServicos.aprovar(this.contratoId)
                .then(res => {
                    if (res && res.success) {
                        this.$toast.success('Cronograma aprovado com sucesso.')
                        this.$router.back()
                    } else {
                        this.$toast.error('Erro ao aprovar cronograma.')
                        if (res && res.errors) res.errors.forEach(e => this.$toast.error(e))
                    }
                })
                .catch(() => {
                    this.$toast.error('Erro ao aprovar cronograma.')
                })
                .finally(() => {
                    this.processando = false
                    this.$store.dispatch('removeRequest')
                })
        },

        resetarModalDevolucao() {
            this.motivo = ''
            this.motivoTocado = false
        },

        confirmarDevolucao() {
            this.motivoTocado = true
            if (!this.motivoValido) return
            if (this.processando) return

            this.processando = true
            this.$store.dispatch('addRequest')
            CronogramaAprovacaoServicos.devolver(this.contratoId, this.motivo.trim())
                .then(res => {
                    if (res && res.success) {
                        this.$toast.success('Cronograma devolvido ao fornecedor.')
                        this.$bvModal.hide('modal-devolver')
                        this.$router.back()
                    } else {
                        this.$toast.error('Erro ao devolver cronograma.')
                        if (res && res.errors) res.errors.forEach(e => this.$toast.error(e))
                    }
                })
                .catch(() => {
                    this.$toast.error('Erro ao devolver cronograma.')
                })
                .finally(() => {
                    this.processando = false
                    this.$store.dispatch('removeRequest')
                })
        }
    },
    created() {
        this.carregar()
    },
    watch: {
        '$route.params.contratoId'(novoId) {
            if (novoId && novoId !== this.contratoId) {
                this.contratoId = novoId
                this.dados = null
                this.contrato = null
                this.historico = []
                this.carregar()
            }
        }
    }
}
</script>
